import { Switch } from 'react-router-dom';
import { AnalyticsRoute } from '@chr/online-shared-ui-analytics';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { Unauthed, Authed } from './common/utility/lazy-load';

import './App.scss';

import Home from './app/areas/home/Home'
import Activation from './app/areas/activation/Activation';
import PageNotFound from './app/areas/page-not-found/page-not-found';
import Guest from './app/areas/guest/guest';
import MergeAccountsWrapper from './app/areas/merge-accounts/merge-accounts-wrapper';
import ProfileConfirmationFormWrapper from './app/areas/profile-confirmation/profile-confirmation-form-wrapper';
import EmailConfirmationCheck from './app/areas/profile-confirmation/email-confirmation-check';

interface AppProps {
  store: Store;
}

export const App = ({ store }: AppProps) => (
  <Provider store={store}>
    <div className="app">
      <Switch>
        <AnalyticsRoute path="/" strict={true} exact={true} component={Authed(Home)} pageName={'Customer Apps | Welcome'}/>
        <AnalyticsRoute path="/welcome" strict={true} exact={true} component={Authed(Home)} pageName={'Customer Apps | Welcome'}/>
        <AnalyticsRoute path="/users/activation" strict={true} exact={true} component={Unauthed(Activation)} pageName={'Customer Apps | Account Activation'}/>
        <AnalyticsRoute path="/guest" strict={true} exact={true} component={Unauthed(Guest)} pageName={'Customer Apps | Log Out'}/>
        <AnalyticsRoute path="/mergeaccounts" strict={true} exact={true} component={Authed(MergeAccountsWrapper)} pageName={'Customer Apps | Merge Accounts'}/>
        <AnalyticsRoute path="/profileconfirmation/:guid" strict={true} exact={true} component={Unauthed(ProfileConfirmationFormWrapper)} pageName={'Customer Apps | Profile Confirmation'}/>
        <AnalyticsRoute path="/emailconfirmation/:guid/:token" strict={true} exact={true} component={Unauthed(EmailConfirmationCheck)} pageName={'Customer Apps | Confirmed Email'}/>
        <AnalyticsRoute
          path="/pagenotfound"
          strict={true}
          exact={true}
          component={Authed(PageNotFound)}
          pageName={'Customer Apps | Page Not Found'}
        />
        <AnalyticsRoute component={Authed(PageNotFound)} pageName={'Customer Apps | Page Not Found'}/>
      </Switch>
    </div>
  </Provider>
);
